import Stack from '@mui/material/Stack';
import KmxHouseStroked from '@kmx/mui-icons/KmxHouseStroked';
import KmxLocationStroked from '@kmx/mui-icons/KmxLocationStroked';

import StepContainer from './StepContainer';
import StepCopyContainer from './StepCopyContainer';
import StepOneImageBox from './StepOneImageBox';

const StepOne = () => (
    <StepContainer className="buying-online-steps--step-1">
        <StepCopyContainer
            heading="1. Choose"
            subHeading={<span>Once you find a car to buy, start by reserving it online.</span>}
        />
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} useFlexGap sx={{ flex: { lg: '1 0 0' } }}>
            <StepOneImageBox
                imageContainerClass="step-1-square-img-container-delivery"
                imageUrl="/home/images/buying-online/steps/buyonline-delivery.jpg"
                textContainerClass="step-1-delivery-text"
                outerLabel="Delivery to"
                chipIcon={<KmxHouseStroked />}
                chipLabel="Home or work"
            />
            <StepOneImageBox
                imageContainerClass="step-1-square-img-container-epu"
                imageUrl="/home/images/buying-online/steps/buyonline-epu.jpg"
                textContainerClass="step-1-epu-text"
                outerLabel="Express pickup at"
                chipIcon={<KmxLocationStroked />}
                chipLabel="CarMax Store"
            />
        </Stack>
    </StepContainer>
);

export default StepOne;
